<template>
	<div class="ct-header-mobile">
		<div class="ct-header-taille">
			<div class="ct-header-style">
				<div id="ct-header-logo-mobile" class="ct-resolution-width">
					<img src="../assets/logo.svg" class="ct-header-logo-img-mobile"/>
					<div class="ct-header-burger-mobile clickable" @click="toggleMenu()" :class="{'ct-header-burger-mobile-actif': open}">&#9776;</div>
				</div>
			</div>
			<div class="ct-toggle ct-resolution-width">
				<div class="ct-header-menu-mobile" :class="{'ct-header-menu-mobile-open': open}">
					<router-link class="ct-header-menu-item ct-clickable" to="/entreprise">
						<div class="ct-header-menu-item-block" @click="toggleMenu()">
							<span>{{ entreprise }}</span>
							<i class="material-icons ct-header-menu-icone"
							   :class="{'ct-header-selected-line': isCurrentPath('/entreprise')}">home</i>
						</div>
					</router-link>

					<router-link class="ct-header-menu-item ct-clickable" to="/realisations">
						<div class="ct-header-menu-item-block" @click="toggleMenu()">
							<span>{{ realisations }}</span>
							<i class="material-icons ct-header-menu-icone"
							   :class="{'ct-header-selected-line': isCurrentPath('/realisations')}">extension</i>
						</div>
					</router-link>

					<router-link class="ct-header-menu-item ct-clickable" to="/contact">
						<div class="ct-header-menu-item-block" @click="toggleMenu()">
							<span>{{ contact }}</span>
							<i class="material-icons ct-header-menu-icone"
							   :class="{'ct-header-selected-line': isCurrentPath('/contact')}">email</i>

						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CtHeader',
		data() {
			return {
				entreprise: 'Entreprise',
				realisations: 'Réalisations',
				contact: 'Contact',
				open: false,
			}
		},
		methods: {
			isCurrentPath(to) {
				return this.$route.path.match(new RegExp("^"+to));
			},
			toggleMenu() {
				this.open = !this.open;
			}
		}
	}
</script>

<style scoped>

	.ct-header-mobile {
		display: flex;
		justify-content: center;
	}

	.ct-header-taille {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
	}

	.ct-header-style {
		display: flex;
		justify-content: center;
		width: 100%;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		background-color: #FAFAFA;

		z-index: 200;
	}

	#ct-header-logo-mobile {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 10px 5px 10px;
	}

	.ct-header-burger-mobile {
		font-size: 2em;
		transition: transform 2s;
		-webkit-transition: transform 2s;
		transition: color 1.5s;
		-webkit-transition:  color 1.5s;
	}

	.ct-header-burger-mobile-actif {
		transform: rotate(90deg);
		transform-origin: center;
		color: #B0E900;
	}

	.ct-header-logo-img-mobile {
		height: 30px;
	}

	.ct-toggle {
		height: 1px;

	}
	.ct-header-menu-mobile {
		display: flex;
		justify-content: flex-end;
		flex-direction: column;
		align-items: flex-end;
		font-family: 'EnterTheGrid';
		font-size: 1.2em;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
		background-color: white;
padding-top: 20px;
		z-index: 100;

		transform: scaleY(0);
		transform-origin: 50% 0;
		transition: transform .8s;
		-webkit-transition: transform .8s;
	}

	.ct-header-menu-mobile-open {
		transform: scaleY(1);
	}

	.ct-header-menu-item {
		padding: 10px 10px 10px 50px;

	}

	.ct-header-menu-item-block {
		display: flex;
		/* align-items: flex-end; */
		align-items: end;
	}

	.ct-header-selected-line {
		color: #B0E900;
	}

	.ct-header-menu-icone {
		padding-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/CtHeaderMobile.vue